import React from 'react';
import InfoBlock from '../../../components/marketing/pageSections/about/InfoBlock';

function BodyAboutPage(props) {
    return (
        <>
            <InfoBlock />
        </>
    );
}

export default BodyAboutPage;